<template>
  <tk-container class="state" :status="status">
    <tkui-header center slot="header">
      <tk-icon slot="left-menu" @click.native="back">Return</tk-icon>
      运行状态
    </tkui-header>
    <div class="body">
      <div v-if="warnings.length" v-for="(item, index) in warnings">
        <h2 class="name" v-if="item.type">告警{{item.type}}</h2>
        <tk-flex middle class="content">
          <div class="index unshrink"></div>
          <div class="fill">
            <h2 class="question">问题描述：{{item.content}}</h2>
            <div class="answer">
              <p>解决办法：</p>
              <p v-html="methods[item.type]"></p>
            </div>
          </div>
        </tk-flex>
      </div>
    </div>
  </tk-container>
</template>

<script>
  export default {
    data () {
      return {
        warnings: [],
        status: false,
        methods: {
          'E0': '检查开水器,保证净水设备的出水压力。检查进水电磁阀。',
          'E1': '水龙头放水，可恢复正常。<br/>' +
          '如果溢流管溢水，请检查进水电磁阀。<br/>' +
          '如果溢流管无溢水，请检查液位管。',
          'E2': '检查水温检测探头',
          'E3': '检查水温检测探头,重新上电恢复'
        },
        warns: {
          'E0': '缺水',
          'E1': '溢水',
          'E2': '测温断路',
          'E3': '温度探头短路'
        }
      }
    },
    created () {
      let warn = this.$getFlash('warn').items
      if (warn !== '00') {
        this.warnings.push({
          type: warn,
          content: this.warns[warn]
        })
      } else {
        this.status = 'empty'
      }
    },
    methods: {
      back () {
        this.$back()
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.state{
  background: #ffffff;
  .body{
    padding: 0 12px;
    .name{
      font-size: 16px;
      color: #E60808;
      text-align: center;
      padding: 15px 0;
    }
    .time{
      font-size: 12px;
      color: #999999;
      line-height: 24px;
    }
    .content{
      border: 1px solid #999999;
      .index{
        width: 20px;
        height: 20px;
        /*border-radius: 50%;*/
        /*background: #E45150;*/
        /*line-height: 20px;*/
        /*text-align: center;*/
        /*color: #ffffff;*/
        /*font-size: 12px;*/
        /*margin: 0 6px;*/
      }
      .question{
        font-size: 14px;
        color: #000000;
        padding: 10px 0;
        border-bottom: 1px solid #999999;
      }
      .answer{
        color: #666666;
        font-size: 12px;
        padding: 5px 0;
        line-height: 20px;
        p {
          margin-bottom: 0!important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/app/detail/warn.vue